<style>
    .ivu-table .demo-table-settled-row td{
        color: #19be6b;
    }

    .ivu-table .demo-table-disc-row td{
        color: #c30e0e;
    }

    .ivu-table .demo-table-claim-row td{
        color: #2db7f5;
    }

    .ivu-table .demo-table-claim-depo-row td{
        color: #c32df5;
    }

    .ivu-table .demo-table-giro-row td{
        color: #de2df5;
    }
</style>

<template>
    <div>

        <Card>
            <p slot="title">
                List Deposit
            </p>

            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="6">
                    <Select
                        style="width: 250px;"
                        placeholder="Ketik Marking"
                        v-model="markingIdSelected"
                        filterable
                        clearable
                        remote
                        :remote-method="getMarkingByCode"
                        :loading="loadingGetMarking"
                        @on-change="getReceivableData()" >
                        <Option v-for="option in optionMarkings"
                            :value="option.value" :key="option.value">{{option.label}}</Option>
                    </Select>

                </Col>
                <Col span="6">
                    <Spin size="large" v-show="loadingGetReceivable"></Spin>
                </Col>
                <Col span="6">
                </Col>
            </Row>

            <br>

            <Card
                v-show="receivables.length > 0">

            <button type="button" @click="generateExcel" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate XLSX</span></button>
            <br/><br/>

                <p slot="title">
                </p>

                <Table
                    :row-class-name="rowClassName"
                    :columns="tableColumns"
                    :data="receivables"

                    no-data-text=""
                ></Table>
            </Card>
        </Card>

        <!-- Modal Tarik Deposit -->
        <Modal v-model="modal.TarikDeposit" width="50%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tarik Deposit</span>
            </p>
            <Form ref="formTarikDeposit" :model="formTarikDeposit" :rules="rulesValidatorTarik">
                <Form-item label="Marking">
                    <Input style="display:none" v-model="formTarikDeposit.markingHeaderId"></Input>
                    <Input style="display:none" v-model="formTarikDeposit.type"></Input>
                    <Input type="text" disabled v-model="formTarikDeposit.markingHeaderCode"></Input>
                </Form-item>

                <Form-item label="Total Deposit">
                    <!-- <Input type="text" disabled v-model="formTarikDeposit.totalAmount"></Input> -->
                    <money
                        v-model="formTarikDeposit.totalAmount"
                        v-bind="moneyTotal"
                        class="ivu-input right"
                        style="width: 100%;" disabled>
                    </money>
                </Form-item>

                <Form-item label="Nominal Tarik">
                            <money
                                v-model="formTarikDeposit.tarikAmount"
                                v-bind="money"
                                class="ivu-input right"
                                style="width: 100%;" ></money>
                                <!-- <font v-show="amountResidue != 0"
                                    style="margin-left: 20px;">
                                    Selisih &nbsp; {{amountResidue | currency}}
                                </font> -->
                        </Form-item>

                <Form-item label="Tanggal Tarik">
                  <Date-picker type="date" style="width: 100%;" placeholder="Masukan Tanggal Tarik" format="yyyy-MM-dd" v-model="formTarikDeposit.date"></Date-picker>
                </Form-item>
                <Form-item label="Kode Penyesuaian" prop="categoryCodeId">
                    <br>
                    <Select
                        style="display:revert"
                        v-model="formTarikDeposit.categoryCodeId"
                        placeholder="Select"
                        clearable
                        filterable>
                        <Option
                            v-for="category in categoriesCode"
                            :value="category.id"
                            :key="category.id">{{ category.category }}</Option>
                    </Select>
                </Form-item>

                <Form-item label="Keterangan Tarik">
                  <Input type="text" v-model="formTarikDeposit.keterangan"></Input>
                </Form-item>

                <Form-item label="Upload File" prop="file">
                    <br>
                    <Upload
                        type="drag"
                        ref="upload"
                        name="fileUploaded"
                        :action="this.serverUrlUploadFile"
                        :before-upload="handleBeforeUpload">
                        <div style="padding: 20px 0">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>Click or drag files here to upload</p>
                        </div>
                    </Upload>
                    <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                </Form-item>
            </Form>

            <div slot="footer">
                <Button
                    v-if="isSaveShow"
                    type="primary"
                    :loading="isLoadingTarikDeposit"
                    @click="postTarikDeposit" >
                    <span v-if="!isLoadingTarikDeposit">Simpan</span>
                    <span v-else>Uploading.....</span>
                </Button>
                <Alert type="warning" v-else="isSaveShow">Semua inputan termasuk upload file wajib diisi !</Alert>
            </div>
        </Modal>

        <!-- Modal Pendapatan Deposit -->
        <Modal v-model="modal.PendapatanDeposit" width="50%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Pendapatan Deposit</span>
            </p>
            <Form ref="formPendapatanDeposit" :model="formPendapatanDeposit" :rules="rulesValidatorPendapatan">
                <Form-item label="Marking">
                    <Input style="display:none" v-model="formPendapatanDeposit.markingHeaderId"></Input>
                    <Input type="text" disabled v-model="formPendapatanDeposit.markingHeaderCode"></Input>
                </Form-item>

                <Form-item label="Total Deposit">
                    <!-- <Input type="text" disabled v-model="formPendapatanDeposit.totalAmount"></Input> -->
                    <money
                        v-model="formPendapatanDeposit.totalAmount"
                        v-bind="moneyTotal"
                        class="ivu-input right"
                        style="width: 100%;" disabled>
                    </money>
                </Form-item>

                <Form-item label="Nominal Pendapatan">
                            <money
                                v-model="formPendapatanDeposit.pendapatanAmount"
                                v-bind="money"
                                class="ivu-input right"
                                style="width: 100%;" ></money>
                        </Form-item>

                <Form-item label="Tanggal Pendapatan">
                  <Date-picker type="date" style="width: 100%;" placeholder="Masukan Tanggal Pendapatan" format="yyyy-MM-dd" v-model="formPendapatanDeposit.date"></Date-picker>
                </Form-item>
                <Form-item label="Kode Penyesuaian" prop="categoryCodeId">
                    <br>
                    <Select
                        style="display:revert"
                        v-model="formPendapatanDeposit.categoryCodeId"
                        placeholder="Select"
                        clearable
                        filterable>
                        <Option
                            v-for="category in categoriesCode"
                            :value="category.id"
                            :key="category.id">{{ category.category }}</Option>
                    </Select>
                </Form-item>

                <Form-item label="Keterangan Pendapatan">
                  <Input type="text" v-model="formPendapatanDeposit.keterangan"></Input>
                </Form-item>
            </Form>

            <div slot="footer">
                <Button
                    v-if="isSavePenShow"
                    type="primary"
                    :loading="isLoadingPendapatanDeposit"
                    @click="postPendapatanDeposit" >
                    <span v-if="!isLoadingPendapatanDeposit">Simpan</span>
                    <span v-else>Uploading.....</span>
                </Button>
                <Alert type="warning" v-else="isSavePenShow">Nominal pendapatan, tanggal pendapatan dan keterangan harus di isi</Alert>
            </div>
        </Modal>

    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import {Money} from 'v-money'
import * as XLSX from 'xlsx'


const numeral = require('numeral');
var axios = require('axios');

export default {
    components: {Money},
    data () {
      return {
        user: {
            username: '',
            role: ''
        },
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        moneyTotal: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        modal: {
          TarikDeposit: false,
          PendapatanDeposit: false
        } ,
        createReceivable: {
            transactionDate: '',
            description: '',
            amount: 0,
            filename: ''
        },
        markingIdSelected: '',
        depositRemaining: Number, // untuk menampung total sisa deposit
        countBalance: Number,
        receivables: [],
        optionMarkings: [],
        formTarikDeposit: {
            markingHeaderCode: '',
            categoryCodeId: '',
            markingHeaderId: '',
            totalAmount: '',
            tarikAmount: 0,
            keterangan: '',
            type: '',
            filename: ''
        },
        formPendapatanDeposit: {
            markingHeaderCode: '',
            categoryCodeId: '',
            markingHeaderId: '',
            totalAmount: '',
            pendapatanAmount: 0,
            type: '',
            keterangan: ''
        },
        loadingGetMarking: false,
        loadingGetReceivable: false,
        isLoadingTarikDeposit: false,
        isLoadingPendapatanDeposit: false,
        isSaveShow: false,
        isSavePenShow : false,
        markings: [],
        subbranchcode: localStorage.getItem('user.subbranchcode'),
        dateToFormat: moment(Date.now(), 'YYYY-MM-DD').toDate(),
        categoriesCode: [],
        categoryCodeId: null,
        tableColumns: [
            {
                type: 'index',
                width: 80,
                align: 'center'
            },
            {
                title: 'Marking',
                key: 'markingHeaderCode',
                type: 'html',
                sortable: false
            },
            {
                title: 'Total Deposit',
                key: 'totalAmount',
                align: 'left',
                sortable: false,
                cellClassName: {
                    name: 'demo-table-info-cell-name'
                },
                render: (h, params) => {
                  const totalAmount = params.row.totalAmount
                  return h('span', {},'Rp.' + numeral(totalAmount).format('0,0'))
                }
            },
            {
                title: 'Type',
                key: 'type',
                align: 'left',
            },
            {
              title: 'Action',
              align: 'center',
              render: (h, params) => {
                const parent = this
                const receivable = params.row
                return h('div', [
                  h('Button', {
                      props: {
                          type: 'success',
                          size: 'small'
                      },
                      style: {
                          marginRight: '5px'
                      },
                      on: {
                          click: function() {
                            parent.showTarikDeposit(receivable)
                          }
                      }
                  }, 'Tarik Deposit'),
                  h('Button', {
                      props: {
                          type: 'primary',
                          size: 'small'
                      },
                      style: {
                          marginRight: '5px'
                      },
                      on: {
                          click: function() {
                            parent.showPendapatanDeposit(receivable)
                          }
                      }
                  }, 'Pendapatan Deposit')
                ])
              }
            }
        ],
        rulesValidatorTarik: {
          tarikAmount: [
            {required: true, type:'text', message: '', trigger: 'blur' }
          ],
          keterangan: [
            {required: true, type:'text', message: 'keterangan tidak boleh kosong', trigger: 'blur' }
          ]
        },
        rulesValidatorPendapatan: {
          pendapatanAmount: [
            {required: true, type:'text', message: '', trigger: 'blur' }
          ],
          keterangan: [
            {required: true, type:'text', message: 'keterangan tidak boleh kosong', trigger: 'blur' }
          ]
        },

        filename: `deposit-list-` +  moment(this.dateToFormat).format("DD-MM-YYYY"),
        serverUrlUploadFile: "",
        isProgress: false,
        pValue: 0,
    }
    },
    methods: {
        clearCreateReceivable(){
            this.createReceivable.transactionDate = ''
            this.createReceivable.description = ''
            this.createReceivable.amount = 0
            this.createReceivable.filename = ''
        },

        rowClassName (row, index) {
            if (row.isSettled) {
                return 'demo-table-settled-row';
            }

            if (row.category == 'disc') {
                return 'demo-table-disc-row';
            }

            if (row.claimId) {
                return 'demo-table-claim-depo-row';
            }

            if (row.claim) {
                return 'demo-table-claim-row';
            }

            if (row.giro) {
                return 'demo-table-giro-row';
            }

            return '';
        },

        getReceivableData: function(){
            let parent = this;

            this.invoiceDues = []
            this.receivables = []
            this.amountResidue = ''
            this.amountReceived = ''
            this.description = ''
            this.depositRemaining = Number
            this.countBalance = Number

            if(this.markingIdSelected == '' || this.markingIdSelected == null){
                this.getReceivableDataAll();
                exit;
            }

            this.loadingGetReceivable = true;

            HTTP
            .post('deposit/marking', {
              markingheadercode: this.markingIdSelected
            })
            .then(resp => {

              const data = resp.data
              this.receivables = data
               this.loadingGetReceivable = false;

            })
            .catch(e => {
                        this.loadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })

        },

        getReceivableDataAll: function(){
            let parent = this;

            this.invoiceDues = []
            this.receivables = []
            this.amountResidue = ''
            this.amountReceived = ''
            this.description = ''
            this.depositRemaining = Number
            this.countBalance = Number

            this.loadingGetReceivable = true;

            HTTP
            .post('deposit/list')
            .then(resp => {
              const data = resp.data
              this.receivables = data

               this.loadingGetReceivable = false;
            })
            .catch(e => {
                        this.loadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })

        },

        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                    // .post('marking/getByCodeAll', {
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.subbranchcode
                    })
                    .then(response => {

                        this.invoiceDues = []
                        this.amountResidue = ''
                        this.amountReceived = ''
                        this.description = ''

                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheadercode,
                                label: item.markingheadercode
                            };
                        });
                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.loadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];


                }
            }, 400
        ),

        isSettled : function (invoice){
            if(invoice != null){
                if(invoice.settledDate != null){
                        return true;
                }
            }

            return false;
        },

        showTarikDeposit: function(receivable) {
          this.formTarikDeposit = {
            markingHeaderCode: receivable.markingHeaderCode,
            markingHeaderId: receivable.markingHeaderId,
            totalAmount: parseFloat(receivable.totalAmount).toFixed(0),
            type: receivable.type,
            date: '',
            keterangan: ''
          }
          this.modal.TarikDeposit = true
        },

        showSaveTarik: function() {
          const totalAmount = this.formTarikDeposit.totalAmount
          const tarikAmount = this.formTarikDeposit.tarikAmount
          const keterangan = this.formTarikDeposit.keterangan
          const categoryCodeId = this.formTarikDeposit.categoryCodeId
          const type = this.formTarikDeposit.type
          const date = this.formTarikDeposit.date
          const filename = this.formTarikDeposit.filename

          if(totalAmount >= tarikAmount && keterangan != '' && categoryCodeId && date != '' && (filename != '' && filename != undefined)) {
            this.isSaveShow = true
          } else {
            this.isSaveShow = false
          }
        },

        handleBeforeUpload (file) {
            console.log({file});

            const formData = new FormData();
            formData.append('file', file);
            formData.append('markingHeaderCode', this.formTarikDeposit.markingHeaderCode);

            this.isProgress = true;
            this.pValue = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

            HTTP
            .post('/payment/file/upload', formData, {
               headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
                console.log("withdrawal upload response :", response);
                this.formTarikDeposit.filename = response.data.filename; // Set filename
                // this.isProgress = false;
                this.pValue = 100;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })

            return false; // Kembalikan false untuk mencegah unggahan otomatis
        },

        postTarikDeposit: function() {
          let tarikDate = this.formTarikDeposit.date != null ? moment(this.formTarikDeposit.date, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD") : ''
          let type = this.formTarikDeposit.type === 'DEPOSIT' ? 'DEP' : 'DFM';

          if(type === 'DEP') {
            const payload = {
              markingHeaderId: this.formTarikDeposit.markingHeaderId,
              transactionDate: tarikDate,
              description: this.formTarikDeposit.keterangan,
              depositAmount: this.formTarikDeposit.tarikAmount,
              withdrawalFilename: this.formTarikDeposit.filename,
              categoryCodeId: this.formTarikDeposit.categoryCodeId
            }

            HTTP
            .post('payment/deposit', payload)
            .then(response => {
              this.modal.TarikDeposit = false
              this.isLoadingTarikDeposit = false
              this.isSaveShow = false

              this.$Notice.success({
                  title: 'Data berhasil di-update ',
                  desc: ''
              });

              this.getReceivableDataAll()
            })
            .catch(e => {
              this.getReceivableDataAll()
              this.modal.TarikDeposit = false
              this.isLoadingTarikDeposit = false
              this.isSaveShow = false

              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
            });
          } else {
            const payload = {
              markingHeaderId: this.formTarikDeposit.markingHeaderId,
              transactionDate: tarikDate,
              description: this.formTarikDeposit.keterangan,
              depositAmount: this.formTarikDeposit.tarikAmount,
              withdrawalFilename: this.formTarikDeposit.filename,
              depositType: 'DFM',
              categoryCodeId : this.formTarikDeposit.categoryCodeId
            }

            HTTP
            .post('payment/deposit', payload)
            .then(response => {
              this.modal.TarikDeposit = false
              this.isLoadingTarikDeposit = false
              this.isSaveShow = false

              this.$Notice.success({
                  title: 'Data berhasil di-update ',
                  desc: ''
              });

              this.getDepositMutation()
            })
            .catch(e => {
              this.getDepositMutation()
              this.modal.TarikDeposit = false
              this.isLoadingTarikDeposit = false
              this.isSaveShow = false

              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
            });
          }

          this.formTarikDeposit.keterangan = ''
          this.formTarikDeposit.date = ''
          this.formTarikDeposit.type = ''
        },

        showPendapatanDeposit: function(receivable) {
          this.formPendapatanDeposit = {
            markingHeaderCode: receivable.markingHeaderCode,
            markingHeaderId: receivable.markingHeaderId,
            totalAmount: parseFloat(receivable.totalAmount).toFixed(0),
            type: receivable.type,
            date: '',
            keterangan: ''
          }
          this.modal.PendapatanDeposit = true
        },

        showSavePendapatan: function() {
          const totalAmount = this.formPendapatanDeposit.totalAmount
          const pendapatanAmount = this.formPendapatanDeposit.pendapatanAmount
          const categoryCodeId = this.formPendapatanDeposit.categoryCodeId
          const keterangan = this.formPendapatanDeposit.keterangan
          const date = this.formPendapatanDeposit.date

          if(totalAmount >= pendapatanAmount && categoryCodeId && keterangan != '' && date != '') {
            this.isSavePenShow = true
          }  else {
            this.isSavePenShow = false
          }
        },

        postPendapatanDeposit: function() {
          let pendapatanDate = this.formPendapatanDeposit.date != null ? moment(this.formPendapatanDeposit.date, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD") : ''
          let type = this.formTarikDeposit.type === 'DEPOSIT' ? 'DEP' : 'DFM';

          if(type == 'DEP') {
            const payload = {
              markingHeaderId: this.formPendapatanDeposit.markingHeaderId,
              transactionDate: pendapatanDate,
              description: this.formPendapatanDeposit.keterangan,
              depositAmount: this.formPendapatanDeposit.pendapatanAmount,
              categoryCodeId: this.formPendapatanDeposit.categoryCodeId
            }

            HTTP
            .post('payment/income', payload)
            .then(response => {
              this.modal.PendapatanDeposit = false
              this.isLoadingPendapatanDeposit = false
              this.isSaveShow = false

              this.$Notice.success({
                  title: 'Data berhasil di-update ',
                  desc: ''
              });

              this.getReceivableDataAll()
            })
            .catch(e => {
              this.getReceivableData()
              this.modal.PendapatanDeposit = false
              this.isLoadingPendapatanDeposit = false
              this.isSaveShow = false

              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
            });
          } else {
            const payload = {
              markingHeaderId: this.formPendapatanDeposit.markingHeaderId,
              transactionDate: pendapatanDate,
              description: this.formPendapatanDeposit.keterangan,
              depositAmount: this.formPendapatanDeposit.pendapatanAmount,
              depositType: 'DFM', // Tambahkan tipe deposit
              categoryCodeId: this.formPendapatanDeposit.categoryCodeId
            }

            HTTP
            .post('payment/income', payload)
            .then(response => {
              this.modal.PendapatanDeposit = false
              this.isLoadingPendapatanDeposit = false
              this.isSaveShow = false

              this.$Notice.success({
                  title: 'Data berhasil di-update ',
                  desc: ''
              });

              this.getDepositMutation()
            })
            .catch(e => {
              this.getDepositMutation()
              this.modal.PendapatanDeposit = false
              this.isLoadingPendapatanDeposit = false
              this.isSaveShow = false

              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
            });
          }

          this.formPendapatanDeposit.keterangan = ''
          this.formPendapatanDeposit.date = ''

        },

        generateExcel: function() {
          var listDepositData = _.map(this.receivables, obj => _.pick(obj, ['markingHeaderCode','createdBy','totalAmount']))
          listDepositData = listDepositData.map(function(value) {
            return {...value, totalAmount: parseInt(value.totalAmount)}
          })
          console.info(listDepositData)
          const data = XLSX.utils.json_to_sheet(listDepositData)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, data, 'List Deposit')

          XLSX.utils.sheet_add_aoa(data, [['Marking', 'Created By', 'Total Deposit']])

          XLSX.writeFile(wb, this.filename + '.xlsx')
        },
        getCategories: function() {
          HTTP.get("category/adjustment")
          .then(response => {
            this.categoriesCode = response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
        },

    },
    filters: {
        currency: function (value) {
        if (!value) return ''
        return numeral(value).format('0,0')
        }
    } ,
  created() {
    //this.getReceivable();
    this.getCategories();
    this.user.username = localStorage.getItem('user.username')
    this.user.role = localStorage.getItem('user.role')
    this.getReceivableDataAll()
  },
  updated() {
    this.showSaveTarik()
    this.showSavePendapatan()
  }
}

</script>



// WEBPACK FOOTER //
// ReceivableDepositList.vue?37908e94